<div class="home-container">
  <div class="home-content">
    <h1 class="home-title">Bienvenido</h1>
    <p class="home-subtitle">Gestión de Órdenes y Paquetes</p>
    
    <div class="home-buttons">
      <button class="home-btn home-btn-primary" routerLink="/orderform">
        <i class="fas fa-plus-circle"></i>
        <span>Agregar Pedido</span>
        <i class="fas fa-arrow-right"></i>
      </button>
      
      <button class="home-btn home-btn-secondary" routerLink="/history">
        <i class="fas fa-list-alt"></i>
        <span>Ver Pedidos</span>
        <i class="fas fa-arrow-right"></i>
      </button>
    </div>
  </div>
</div>